import React from 'react'
import PropTypes from 'prop-types'
import { useFieldId } from 'components/ds/Field'
import styles from './Choice.module.scss'

const cx = (...p) => p.filter(Boolean).join(' ')

const Choice = React.forwardRef(function Choice(props, ref) {
  const { id, type, proxyClassName, proxyChildren, label, disabled, className, ...rest } = props
  const fieldId = useFieldId(id)

  return (
    <label className={cx(styles.choice, disabled && styles.disabled, className)} htmlFor={fieldId}>
      <input
        ref={ref}
        id={fieldId}
        type={type}
        className={styles.input}
        disabled={disabled}
        {...rest}
      />
      <span className={proxyClassName} aria-hidden="true">{proxyChildren}</span>
      {label && <span className={styles.text}>{label}</span>}
    </label>
  )
})

export const Checkbox = React.forwardRef(function Checkbox(props, ref) {
  return <Choice ref={ref} type="checkbox" proxyClassName={styles.box} {...props} />
})

export const Radio = React.forwardRef(function Radio(props, ref) {
  return <Choice ref={ref} type="radio" proxyClassName={styles.dot} {...props} />
})

export const Switch = React.forwardRef(function Switch(props, ref) {
  return (
    <Choice
      ref={ref}
      type="checkbox"
      role="switch"
      proxyClassName={styles.track}
      proxyChildren={<span className={styles.thumb} />}
      {...props}
    />
  )
})

const choicePropTypes = {
  id: PropTypes.string,
  label: PropTypes.node,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}

Checkbox.propTypes = choicePropTypes
Radio.propTypes = choicePropTypes
Switch.propTypes = choicePropTypes

export const ChoiceGroup = ({ legend, row, children, className }) => (
  <fieldset className={cx(styles.group, className)}>
    {legend && <legend className={styles.legend}>{legend}</legend>}
    <div className={cx(styles.groupItems, row && styles.groupItemsRow)}>{children}</div>
  </fieldset>
)

ChoiceGroup.propTypes = {
  legend: PropTypes.node,
  row: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
}

export default Checkbox
